export default __webpack_public_path__ + "static/media/menu.43ac8666.svg";